module.exports = __webpack_public_path__ + "img/mv01.2fadbb2d.png";